import React, { useState } from 'react'
import { FormTab } from './FormTab'

export default function ContactSupportForm(props) {
  const [tabsVisible, setTabsVisible] = useState(true)
  const [selectedTab, setSelectedTab] = useState(0)

  return (
    <>
      {tabsVisible && (
        <div className="w-full flex-nowrap inline-flex justify-start xl:justify-center border-2 border-blue-900 rounded-lg overflow-hidden">
          {props.tabs &&
            props.tabs.map((tab, i) => {
              return (
                <button
                  key={`tab-cta-${i}`}
                  onClick={() => setSelectedTab(i)}
                  className={`hover:bg-blue-900 hover:bg-opacity-10 relative flex-grow lg:w-1/3 px-4 py-2 text-sm lg:text-xl whitespace-nowrap text-center ${
                    selectedTab === i ? 'is-active bg-blue-900 text-white hover:bg-opacity-100' : ''
                  }`}
                >
                  {tab.title}
                </button>
              )
            })}
        </div>
      )}

      {props.tabs &&
        props.tabs.length > 0 &&
        props.tabs.map((tab, i) => {
          return (
            <FormTab
              key={`form-tab-${i}`}
              active={selectedTab === i}
              {...tab}
              pageLocale={props.locale}
              userLocation={props.userLocation}
              loadingText={props.loadingText}
              onSubmitted={() => setTabsVisible(false)}
            />
          )
        })}
    </>
  )
}
